import {IElementBase} from '../base/elementBase';
import {ISlideChangeable} from '../base/slideChangeable';
import {ELEMENT} from '../base/ElementTypes';

export interface IElementHtml extends IElementBase, ISlideChangeable {
    type: ELEMENT.HTML;
    text: string;
    scriptText: string;
    fontColor: string;
    coverSlide?: boolean;
}

export function isCoverHtmlElement(element: {type: string; coverSlide?: boolean}): boolean {
    return element.type === ELEMENT.HTML && Boolean(element.coverSlide);
}
